import React, { Component } from 'react';
import { isEmpty } from '../../../Common/Common';

import Top_Bar from '../../../Part_Sample/Top_Bar';
import Multi_Line_Select from '../../../Part_Sample/Multi_Line_Select';

export default class Schedule_Step2_Target extends Component {
	constructor(props) {
		super(props);
		this.program = {};
		let selected_targets = [];
		if (!isEmpty(this.props.param.program)) {
			this.program = JSON.parse(JSON.stringify(this.props.param.program));
			if (this.program.target != null) {
				selected_targets = this.program.target;
			}
		}

		let point_list = window.app.state.point_list;
		let point_list_display = [];
		let group_list_display = [];
		let scene_list_display = [];
		let program_list_display = [];

		for (let point_id in point_list) {
			//Tommy - 02/03/2021 - Added Shutter, Lock, Rgbw
			// Kaiwei 20210312 add hrv
			let allowed_types = ['Ac', 'Dehumi', 'Switch', 'Level', 'LevelSw', 'Shutter', 'Lock', 'Rgbw', 'Hrv'];
			if (allowed_types.includes(point_list[point_id].type)) {
				let line_item = {};
				line_item.key = point_id;
				line_item.display = point_list[point_id].name;
				line_item.is_checked = selected_targets.includes(point_id) ? true : false;
				point_list_display.push(line_item);
			}
		}

		for (let grp_id in this.props.param.groups) {
			let line_item = {};
			line_item.key = grp_id;
			line_item.display = this.props.receiver.getString(this.props.param.groups[grp_id].name);
			line_item.is_checked = selected_targets.includes(grp_id) ? true : false;
			group_list_display.push(line_item);
		}

		for (let scene_id in this.props.param.scenes) {
			let line_item = {};
			line_item.key = scene_id;
			line_item.display = this.props.param.scenes[scene_id].name;
			line_item.is_checked = selected_targets.includes(scene_id) ? true : false;
			scene_list_display.push(line_item);
		}

		for (let id in this.props.param.interlock.program) {
			let line_item = {};
			line_item.key = id;
			line_item.display = this.props.param.interlock.program[id].name;
			line_item.is_checked = selected_targets.includes(id) ? true : false;
			program_list_display.push(line_item);
		}

		for (let id in this.props.param.schedule.program) {
			let line_item = {};
			line_item.key = id;
			line_item.display = this.props.param.schedule.program[id].name;
			line_item.is_checked = selected_targets.includes(id) ? true : false;
			program_list_display.push(line_item);
		}

		this.state = {
			selected_targets: selected_targets,
			target_type: 'devices',
			point_list_display: point_list_display,
			group_list_display: group_list_display,
			scene_list_display: scene_list_display,
			program_list_display: program_list_display,

			display_list: point_list_display,
		}
	}

	handlePrevious = () => {
		let param = this.props.param;
		this.program.target = this.state.selected_targets;
		param.program = this.program;
		if (param.from == 'Schedule_Office_Summary') {
			let from = param.from;
			if (this.props.param.program_id != null) {
				param.from = 'Schedule';
			} else {
				delete param.from;
			}
			this.props.content_handler(from, param);
		} else if (param.from != null) {
			let from = param.from;
			delete param.from;
			this.props.content_handler(from, param);
		} else {
			this.props.content_handler('Schedule_Step1_Name', param);
		}
	}

	handleShowControlTargets = (tab) => {
		let display_list = []
		if (tab == 'devices') {
			display_list = this.state.point_list_display;
		} else if (tab == 'groups') {
			display_list = this.state.group_list_display;
		} else if (tab == 'scenes') {
			display_list = this.state.scene_list_display;
		} else if (tab == 'program') {
			display_list = this.state.program_list_display;
		}

		this.setState({
			target_type: tab,
			display_list: display_list
		})
	}

	updateSelectedTargets = (val) => {
		let selected_targets = this.state.selected_targets;
		if (selected_targets.includes(val)) {
			selected_targets.splice(selected_targets.indexOf(val), 1);
		} else {
			selected_targets.push(val);
		}

		if (this.state.target_type == 'devices') {
			let point_list_display = this.state.point_list_display;
			for (let i in point_list_display) {
				if (point_list_display[i].key == val) {
					point_list_display[i].is_checked = !point_list_display[i].is_checked;
					break;
				}
			}
			this.setState({ point_list_display: point_list_display })
		} else if (this.state.target_type == 'groups') {
			let group_list_display = this.state.group_list_display;
			for (let i in group_list_display) {
				if (group_list_display[i].key == val) {
					group_list_display[i].is_checked = !group_list_display[i].is_checked;
					break;
				}
			}
			this.setState({ group_list_display: group_list_display })
		} else if (this.state.target_type == 'scenes') {
			let scene_list_display = this.state.scene_list_display;
			for (let i in scene_list_display) {
				if (scene_list_display[i].key == val) {
					scene_list_display[i].is_checked = !scene_list_display[i].is_checked;
					break;
				}
			}
			this.setState({ scene_list_display: scene_list_display })
		} else if (this.state.target_type == 'program') {
			let program_list_display = this.state.program_list_display;
			for (let i in program_list_display) {
				if (program_list_display[i].key == val) {
					program_list_display[i].is_checked = !program_list_display[i].is_checked;
					break;
				}
			}
			this.setState({ program_list_display: program_list_display })
		}
		this.setState({ selected_targets: selected_targets })
	}

	handleRegister = () => {
		if (this.state.selected_targets.length < 1) {
			window.app.showToast(this.props.receiver.getString('no_target'), 3000);
			return
		}
		let param = this.props.param;
		this.program.target = this.state.selected_targets;
		param.program = this.program;
		if (param.from == 'Schedule_Office_Summary') {
			param.from = 'Schedule_Step3_Pattern';
			this.props.content_handler('Schedule_Office_Summary', param);
		} else {
			param.from = 'Schedule_Step2_Target';
			this.props.content_handler('Schedule_Step3_Pattern', param);
		}
	}

	render() {
		let style = {
			textAlign: 'center',
			width: '100%',
		}

		let main_content_style = {
			position: 'fixed',
			top: 0,
			width: '100%',
			height: this.props.height,
		}

		// Tommy - 11/04/2021
		//Controller Options Validation
		let available_functions = this.props.receiver.active_controller.available_functions;

		return (
			<div style={style}>
				<div id='main_content' style={main_content_style} className='slideInDown noScrollBar'>
					<Top_Bar
						width={this.props.width}
						title={this.props.param.program_id == null ? this.props.receiver.getString('sel_target') : this.props.receiver.getString('edit_sched')}
						left_button_type={'back'}
						handleLeftButton={this.handlePrevious}
					/>
					<div style={{ height: this.props.height - 120 }}>
						<div style={{ marginLeft: 20, textAlign: 'left', marginBottom: 20 }}>
							<span className='title' style={{ fontSize: 20 }}>{this.props.receiver.getString('schedule_step2_instr')}</span>
						</div>
						<div style={{ verticalAlign: 'bottom', width: '100%', padding: 0, }}>
							<span className='title' style={{ cursor: 'pointer', display: 'inline-block', marginLeft: 0, maxheight: 40, width: '25%', padding: '10px 0px', textAlign: 'center', backgroundColor: this.state.target_type == 'devices' ? this.props.colours.midnight_sky : 'white', color: this.state.target_type == 'devices' ? 'white' : 'black' }} onClick={() => this.handleShowControlTargets('devices')}>{this.props.receiver.getString('device')}</span>
							<span className='title' style={{ cursor: 'pointer', display: 'inline-block', marginLeft: 0, maxheight: 40, width: '25%', padding: '10px 0px', textAlign: 'center', backgroundColor: this.state.target_type == 'groups' ? this.props.colours.midnight_sky : 'white', color: this.state.target_type == 'groups' ? 'white' : 'black' }} onClick={() => this.handleShowControlTargets('groups')}>{this.props.receiver.getString('group')}</span>
							<span className='title' style={{ cursor: 'pointer', display: available_functions.scene ? 'inline-block' : 'none', marginLeft: 0, maxheight: 40, width: '25%', padding: '10px 0px', textAlign: 'center', backgroundColor: this.state.target_type == 'scenes' ? this.props.colours.midnight_sky : 'white', color: this.state.target_type == 'scenes' ? 'white' : 'black' }} onClick={() => this.handleShowControlTargets('scenes')}>{this.props.receiver.getString('scene')}</span>
							<span className='title' style={{ cursor: 'pointer', display: available_functions.interlock || available_functions.schedule ? 'inline-block' : 'none', marginLeft: 0, maxheight: 40, width: '25%', padding: '10px 0px', textAlign: 'center', backgroundColor: this.state.target_type == 'program' ? this.props.colours.midnight_sky : 'white', color: this.state.target_type == 'program' ? 'white' : 'black' }} onClick={() => this.handleShowControlTargets('program')}>{this.props.receiver.getString('program')}</span>
						</div>
						<Multi_Line_Select width={this.props.width} height={this.props.height - 211} item_list={this.state.display_list} onSelect={this.updateSelectedTargets} />
					</div>

				</div>
			</div>
		)
	}
}